import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

// Estado do diálogo de criação/edição. Quando a tela é aberta pela rota de "novo"
// (ex.: /dashboard-newcategories), já abre em modo de criação e volta para a lista ao fechar.
const useCatalogForm = ({ startCreating, listPath, buildInitial }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [form, setForm] = useState(null);

  const openCreate = () => setForm({ mode: "create", item: null, ...buildInitial(null) });
  const openEdit = (item) => setForm({ mode: "edit", item, ...buildInitial(item) });

  useEffect(() => {
    if (startCreating) openCreate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startCreating]);

  const close = () => {
    setForm(null);
    if (listPath && pathname !== listPath) history.replace(listPath);
  };

  const update = (changes) => setForm((prev) => (prev ? { ...prev, ...changes } : prev));

  return { form, openCreate, openEdit, close, update };
};

export default useCatalogForm;
